export default __webpack_public_path__ + "static/media/JOE.db647b9d.png";